<template>
  <b-card v-if="!!option" id="page-category-product-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.category_products.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="categoryProduct.name"
                    :disabled="option === 2 ? true : false"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormTimepicker,
  BListGroup,
  BListGroupItem,
  BFormDatepicker,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { getCatalog, postFile } from "@core/api/request/catalogs";

import {
  createOrEditCategoryProduct,
  allCategoryProductsByCompany,
} from "@core/api/request/categoryProducts";

const categoryProduct = {
  idCompanyCategoryProducts: null,
  guidCompany: null,
  name: "",
};

export default {
  components: {
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BFormSelect,
    BToast,
    BFormInvalidFeedback,
    BFormTimepicker,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    required,
    option: "",
    guidCompany: null,
    categoryProduct: Object.assign(categoryProduct),
    itemsPage: 1,
    itemsRows: 10,
  }),
  computed: {},

  created() {
    localize("es");
    this.initialize();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.categoryProduct.guidCompany = guid;
      this.guidCompany = guid;
      console.log("guidCompany watch", this.categoryProduct.guidCompany);
    },
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.category_products.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "categoryProducts" }).catch(() => {});
      }
      switch (this.option) {
        case 1:
          this.onCancel();
          this.categoryProduct.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          this.guidCompany = this.$store.state.appConfig.activeCompanyGuid;
          console.log("guidCompany created", this.categoryProduct.guidCompany);
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            router.push({ name: "categoryProducts" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          console.log("guid", this.$route.params.guid, this.$route.params.name);
          this.categoryProduct.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          this.guidCompany = this.$store.state.appConfig.activeCompanyGuid;
          console.log("guidCompany created", this.categoryProduct.guidCompany);
          await this.getCategoryProduct(
            this.$route.params.guid,
            this.$route.params.name,
          );
          break;
      }
    },

    chargeParams(id, name) {
      let arrParams = [];
      arrParams.push(`page,${this.itemsPage}`);
      arrParams.push(`rows,${this.itemsRows}`);
      arrParams.push(`guidCompany,${id}`);
      arrParams.push(`name,${name}`);
      return getParams(arrParams);
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();
          const idCompanyCategoryProducts =
            this.option === 1
              ? null
              : this.categoryProduct.idCompanyCategoryProducts;

          const body = {
            idCompanyCategoryProducts: idCompanyCategoryProducts,
            guidCompany: this.categoryProduct.guidCompany,
            name: this.categoryProduct.name,
          };
          console.log("body", body, idCompanyCategoryProducts);
          createOrEditCategoryProduct(body, idCompanyCategoryProducts)
            .then(() => {
              this.alertToast(
                "success",
                this.$t("Alert"),
                `${
                  this.option != 3
                    ? this.$t("registerSuccess")
                    : this.$t("updateRecord")
                }`,
                "CheckIcon",
              );
              this.goBack();
            })
            .catch((error) => {
              console.error("Error loading data", error.message);
              this.alertToast(
                "danger",
                this.$t("Alert"),
                error.message,
                "AlertTriangleIcon",
              );
            })
            .finally(() => {
              stopLoading();
            });
        }
      });
    },

    getCategoryProduct(idCategoryProduct, name) {
      showLoading();
      const params = this.chargeParams(idCategoryProduct, name);
      allCategoryProductsByCompany(params)
        .then((resp) => {
          const categoryProduct = _.get(resp, "data", []);
          if (Array.isArray(categoryProduct?.items)) {
            const data = categoryProduct.items[0];

            this.categoryProduct = Object.assign(this.categoryProduct, {
              idCompanyCategoryProducts: data.idCompanyCategoryProducts || null,
              guidCompany: data.guidCompany || "",
              name: data.name || "",
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast(
            "danger",
            this.$t("Alert"),
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {
          stopLoading();
        });
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
      this.onCancel();
    },

    onCancel() {
      Object.assign(this.categoryProduct, {
        idCompanyCategoryProducts: "",
        guidCompany: "",
        name: "",
      });
      this.guidCompany = "";
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss"></style>
